import { render, staticRenderFns } from "./drill-down.vue?vue&type=template&id=0ba0e810&scoped=true"
import script from "./drill-down.ts?vue&type=script&lang=ts&external"
export * from "./drill-down.ts?vue&type=script&lang=ts&external"
import style0 from "./drill-down.scss?vue&type=style&index=0&id=0ba0e810&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0e810",
  null
  
)

export default component.exports